import { Form, Input, Select } from "antd";
import { countries } from "countries-list";

export const ProfileFormInputs = () => <>
    <Form.Item
        name="firstName"
        label="First Name"
        rules={[{ required: true, message: 'Please enter your first name' }]}
    >
        <Input />
    </Form.Item>

    <Form.Item
        name="lastName"
        label="Last Name"
        rules={[{ required: true, message: 'Please enter your last name' }]}
    >
        <Input />
    </Form.Item>

    <Form.Item
        name="country"
        label="Country"
        rules={[{ required: true, message: 'Please select a country' }]}
    >
        <Select showSearch options={
            Object.keys(countries).map((c) => {
                const cv = countries[c as keyof typeof countries];
                return { value: c, label: `${cv.emoji} ${cv.name}` };
            })} 
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            />
        {/* <Input /> */}
    </Form.Item>

    <Form.Item
        name="organization"
        label="Organization"
        rules={[{ required: true, message: 'Please enter your organization' }]}
    >
        <Input />
    </Form.Item>

    <Form.Item
        name="phone"
        label="Phone"
        rules={[{ required: true, message: 'Please enter your phone number' }]}
    >
        <Input />
    </Form.Item>
</>